const MCPInformationBox = ({ agency }) => {
  return (
    <div className='bg-main-white rounded-pill racing-border specific-padding-1  mb-2'>
      <div className='bg-main-white rounded-pill  p-3'>
        <p
          className={`mb-0 d-flex flex-column flex-lg-row align-items-center justify-content-between ${agency ? 'px-2 text-center' : 'px-4'}`}
        >
          <span className={`${agency ? 'text-center w-100' : ''}`}>
            Want to build your own public affairs agent? Use PolicyMogul inside Copilot, ChatGPT, Claude and other AI
            tools{' '}
          </span>
          {!agency && (
            <span className='mt-2 mt-lg-0 d-lg-inline-block text-italic text-light-blue  pl-lg-5'>
              Included on every plan
            </span>
          )}
        </p>
      </div>
    </div>
  );
};

export default MCPInformationBox;
